export { default as defaultTemplate } from './defaultTemplate';
export { default as withAuth } from './withAuth';



// WEBPACK FOOTER //
// ./src/core/hoc/index.js